import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  main: {
    width: '75%',
    background: theme.palette.grey[800],
    height: 60,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  connectorAlternativeLabel: {
    top: 22
  },
  connectorLine: {
    height: 2,
    border: 0,
    backgroundColor: theme.palette.grey[500],
    borderRadius: 1,
    margin: '0px 10px',
    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  },
  connector: {
    margin: '0px 10px',
    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  },
  connectorActive: {
    backgroundColor: theme.palette.primary.contrastText,
    '& $connectorLine': {
      backgroundColor: theme.palette.primary.contrastText
    }
  },
  connectorCompleted: {
    '& $connectorLine': {
      backgroundColor: '#555'
    }
  },
  stepIconRoot: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: (props: { active: boolean }) =>
      props.active ? theme.palette.primary.main : theme.palette.grey[500],
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      width: 24,
      height: 24
    }
  },
  completedIcon: {
    backgroundColor: `${theme.palette.primary.main} !important`
  },

  stepLabelRoot: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    background: theme.palette.grey[800]
  },
  stepLabelLabel: {
    marginLeft: theme.spacing(1),
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.primary.contrastText,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      marginLeft: 0
    }
  },
  stepLabelActive: {
    color: `${theme.palette.primary.contrastText} !important`
  },
  stepLabelCompleted: {
    color: `${theme.palette.primary.contrastText} !important`
  }
}))
